import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceNonBreakingSpaces'
})
export class ReplaceNonBreakingSpacesPipe implements PipeTransform {

  public transform(value: string | null | undefined): string {
    return (value ?? '').split(/\s|&nbsp;/g).join(' ');
  }
}
